import { render, staticRenderFns } from "./productFileManagement.vue?vue&type=template&id=837ab776&scoped=true&"
import script from "./productFileManagement.vue?vue&type=script&lang=js&"
export * from "./productFileManagement.vue?vue&type=script&lang=js&"
import style0 from "./productFileManagement.vue?vue&type=style&index=0&id=837ab776&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837ab776",
  null
  
)

export default component.exports